<template >
        <el-dialog title="Select Dates From and To" 
        :visible.sync="show" 
        @close="$emit('update:isVisible', false)" 
        :close-on-click-modal="false"
        width = "30%"
        
        >
            <div style="height: 70px;">
                <div style = "align-items: center">
                    <div style = "align-items: center">
                        <!-- <span >Range</span> -->
                        <el-date-picker
                        v-model="pdfDateRange"
                        type="daterange"
                        size="mini"
                        start-placeholder="Start date"
                        end-placeholder="End date"
                        :picker-options="pickerOptions">
                        </el-date-picker>
                    </div>
                    
                </div>
                <div style= "padding-top: 10px;">
                    <el-button class= "button" @click="makePdf" style= "float: right">Submit</el-button>
                </div>
            </div>
            
        </el-dialog>
       
</template>
<script>
export default {
    data() {
        return {
            pdfDateRange:'',
            show: this.isVisible,
            pickerOptions: {}
        }
    },
    props: {
        isVisible: Boolean,
    },
    watch: {
       isVisible(value) {
      this.show = value;
    },
    },
    
    methods: {
        /**
         * Call the history page to make the pdf and send date values
         * @function
         */
        makePdf()
        {
            if(this.pdfDateRange.length==2){
                this.$emit('update:isVisible', false)
                this.$emit('makePdf', this.pdfDateRange)
            }
        }
        
    },
    mounted() {
        this.pickerOptions = {disabledDate(time) {
            return time.getTime() > Date.now();
          }
        }
    }
    
}
</script>
<style scoped>

.button {
    background-color: #b3282d;
    color: white;
    border-color: white;
    padding: 10px 15px;
}
.button:focus {
    background-color: #9a0f14;
    color: white;
    border-color: white;
    outline: none;
}
.button:hover {
    background-color: #9a0f14;
    color: white;
    border-color: white;
    outline: none;
}
</style>